import * as z from 'zod';

export const emailHistoryQueryLinkerSchema = z.object({
  id: z.number(),
  email_subject: z.string().nullable(),
});

export type EmailHistoryQueryLinkerSchema = z.infer<typeof emailHistoryQueryLinkerSchema>;
